import { H5 } from '../../../AbstractElements';
import React, { Fragment } from 'react';

import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { OrderStatusProgressSeries } from '../../../Data/Widgets/Chart/ChartData';
import { OrderStatus } from '../../../Constant';
import { FiShoppingBag } from 'react-icons/fi';
import ProgressBarChart from './ProgressBarChart';

const OrderStatusChart = () => {
  return (
    <Fragment>
      <Col xl='8' lg='12' className='box-col-6 xl-50'>
        <Card>
          <CardHeader className='pb-0'>
            <Row>
              <Col xs='9'>
                <H5>{OrderStatus}</H5>
              </Col>
              <Col xs='3' className='text-end'>
                <FiShoppingBag style={{ width: '20px', height: '20px' }} className='text-muted' />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <div className='chart-container'>
              {OrderStatusProgressSeries.map((chartData, i) => (
                <ProgressBarChart index={i} key={i} chartData={chartData} />
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default OrderStatusChart;
